import { PasswordRequester } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import {
  changePasswordByRecoveryTokenFailed,
  changePasswordByRecoveryTokenSucceeded,
  forgetPasswordFailed,
  forgetPasswordSucceeded,
  validateTokenFailed,
  validateTokenSucceeded,
} from '@cobliteam/store/src/Password/actionCreators';
import type { ChangePasswordByRecoveryTokenRequest, ForgetPasswordRequest, ValidateTokenRequest } from '@cobliteam/store/src/Password/actions';
import { PasswordActionTypes } from '@cobliteam/store/src/Password/actionTypes';
import Alert from '@cobliteam/ui/components/Alert';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const env = Environment.getInstance().getEnvironment();

export class PasswordSagas {
  private passwordRequester: PasswordRequester;

  constructor(passwordRequester: PasswordRequester) {
    this.passwordRequester = passwordRequester;
    this.requestChangePasswordByRecoveryTokenSaga = this.requestChangePasswordByRecoveryTokenSaga.bind(this);
    this.requestForgetPasswordSaga = this.requestForgetPasswordSaga.bind(this);
    this.requestValidateTokenSaga = this.requestValidateTokenSaga.bind(this);
  }

  // Password Recovery

  public *requestChangePasswordByRecoveryTokenSaga(action: ChangePasswordByRecoveryTokenRequest) {
    try {
      const { token, password } = action.payload;
      yield call(this.passwordRequester.changePasswordByRecoveryToken, token, password);

      yield put(changePasswordByRecoveryTokenSucceeded());
      Alert.success('Senha atualizada com sucesso!');
    } catch (err) {
      yield put(changePasswordByRecoveryTokenFailed());
    }
  }

  // Foget password (token request)

  public *requestForgetPasswordSaga(action: ForgetPasswordRequest) {
    try {
      yield call(this.passwordRequester.forgetPassword, action.payload.email);
      yield put(forgetPasswordSucceeded());
      Alert.success('Um e-mail foi enviado para você com um novo código de segurança');
    } catch (err) {
      yield put(forgetPasswordFailed());
      Alert.error('Este e-mail não é válido');
    }
  }

  // Token validation

  public *requestValidateTokenSaga(action: ValidateTokenRequest) {
    try {
      yield call(this.passwordRequester.validateToken, action.payload.token);
      yield put(validateTokenSucceeded());
      Alert.success('Código de segurança validado com sucesso');
    } catch (err) {
      yield put(validateTokenFailed());
      Alert.error('O código de segurança inserido não é válido');
    }
  }
}

export function* PasswordSagasListener() {
  const passwordSagas = new PasswordSagas(new PasswordRequester({ host: env.herbieApiHost }));
  yield all([
    takeLatest(PasswordActionTypes.CHANGE_PASSWORD_BY_RECOVERY_TOKEN_REQUEST, passwordSagas.requestChangePasswordByRecoveryTokenSaga),
    takeLatest(PasswordActionTypes.VALIDATE_TOKEN_REQUEST, passwordSagas.requestValidateTokenSaga),
    takeLatest(PasswordActionTypes.FORGET_PASSWORD_REQUEST, passwordSagas.requestForgetPasswordSaga),
  ]);
}
